export default {
    addFriend: 'Add Friend',
    addNote: 'Add Note',
    addNotification: 'Add Notification',
    banned: "You do not have permission to view this model's menu.",
    bookmark: 'Bookmark',
    bookmarked: 'Bookmarked',
    camscore: 'CamScore',
    chatArchives: 'Chat Archives',
    closeNotes: 'Close Notes',
    enterChat: 'Enter Chat',
    enterLounge: 'Enter Lounge',
    friended: 'Friended',
    hideModel: 'Hide Model',
    ignoreModel: 'Ignore Model',
    ignoreUser: 'Ignore User',
    kicked: 'You have been kicked from the room and do not have permission to view this menu',
    mfc_rank: 'MFC Rank: ',
    missMFC: 'Miss MFC',
    modelHidden: 'Model Hidden',
    modelHiddenMessage: 'To unhide: More > Hidden Models',
    modelHiddenTitle: 'Model has been hidden!',
    modelIgnored: 'Model Ignored',
    notes: 'Notes',
    offlineTip: 'Offline Tip',
    openMenu: 'Open Menu',
    pinModel: 'Pin Model',
    report: 'Please state why you wish to report ',
    reportErrorMessage:
        'We encountered an error. Please try again or email contact support (via your Account Menu)',
    reportModel: 'Report Model',
    reportUser: 'Report User',
    reportSuccessMessage: 'Thanks, we got your your report!',
    reportUserPlaceholder: 'Enter your report (10 character minimum)',
    sendMFCMail: 'Send MFC Mail',
    sendMessage: 'Send Message',
    sendQuickReply: 'Quick Reply',
    sendReport: 'Send Report',
    tipModel: 'Tip Model',
    typeNote: 'Type note...',
    unpinModel: 'Unpin Model',
    userIgnored: 'User Ignored',
    userNotFound: 'User not found',
    viewableMenu: 'for a viewable menu.',
    viewInLounge: 'View in Lounge',
    viewOrEditNotes: 'View/Edit Notes',
    viewProfile: 'View Profile',
    mfcProfile: 'Full MFC Profile',
    whiteboard: 'Whiteboard',
}
